import { Fields } from "../../../FieldNames";
import { getFieldLabelId } from "../../../../helpers/contentTypeLabelId";
import { FieldType } from "../../../../types/ContentType/fields";
export var publicationMetaDateField = {
  type: FieldType.MetaPublicationDate,
  name: Fields.PUBLICATION_TIMESTAMP,
  labelId: getFieldLabelId(Fields.PUBLICATION_TIMESTAMP)
};